const ColorboxdLogo = () => {
  return (
    <div className='font-mono h-min'>
      <span className='text-cb1'>c</span>
      <span className='text-cb2'>o</span>
      <span className='text-cb3'>l</span>
      <span className='text-cb4'>o</span>
      <span className='text-cb5'>r</span>
      <span className='text-cb6'>b</span>
      <span className='text-cb7'>o</span>
      <span className='text-cb8'>x</span>
      <span className='text-cb9'>d</span>
    </div>
  );
};

export default ColorboxdLogo;
